import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreTypeItem, IDictionariesStore, IDictionariesActions } from '../types';

const onRestoreTypeItem: IThunkRestoreTypeItem = thunk(
  async ({ setTypeList }: Actions<IDictionariesActions>, payload, { getState }) => {
    const { type, id, clinicId } = payload;
    const localState = getState() as IDictionariesStore;

    await api.dictionaries.restoreTypeItem(type, id, clinicId);

    const updatedList = localState.list.map(item =>
      item.id !== payload.id ? item : { ...item, isArchived: false },
    );
    setTypeList({ items: updatedList });
  },
);

export default onRestoreTypeItem;
